import { ComponentPropsWithoutRef } from "react";
import { SectionForm as ISectionForm } from "~/sanity/types";
// @ts-ignore
import GravityFormForm from "next-gravity-forms";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionForm.css";
import { Accordion } from "~/components/elements/Accordion";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { LoaderFunctionArgs } from "@remix-run/cloudflare";
import { useLoaderData, useRouteLoaderData } from "@remix-run/react";
import { loader } from "~/root";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion as IAccordion } from "~/sanity/types";

export type SectionFormProps = ComponentPropsWithoutRef<"div"> & {
  data: ISectionForm;
  form: any;
  accordionItems?: IAccordion;
};

export const SectionForm = ({
  data,
  form,
  accordionItems,
  ...props
}: SectionFormProps) => {
  // console.log("sectionForm", form);
  const industry = useRouteLoaderData<typeof loader>("root")?.siteTheme;
  const { title, text } = data;
  return (
    <section {...props}>
      <Grid className={styles.wrapper}>
        <div className={styles.content}>
          {title && (
            <Heading size="h1" as="h2" uppercase>
              {title}
            </Heading>
          )}
          {text && <PortableText blocks={text as IPortableText} />}
          {accordionItems && (
            <Accordion
              accordionItems={accordionItems}
              defaultOpen={accordionItems.length <= 1 ? true : false}
            />
          )}
        </div>
        <div className={styles.form}>
          <div
            className={styles.formContainer({
              hasAccordion: accordionItems ? true : false,
            })}
          >
            <GravityFormForm {...form} presetValues={{ Industry: industry }} />
          </div>
        </div>
      </Grid>
    </section>
  );
};
